import { useCallback, useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import type { TipTapContent } from "./textTypes";

export const useTextBlockUpdate = (blockPath: string) => {
  const {
    selectedBlockPath,
    getSelectedBlock,
    updateSelectedBlock,
    shouldAllowInlineEditing,
  } = useBuilderStore(state => ({
    selectedBlockPath: state.selectedBlockPath,
    getSelectedBlock: state.getSelectedBlock,
    updateSelectedBlock: state.updateSelectedBlock,
    shouldAllowInlineEditing: state.shouldAllowInlineEditing,
  }));

  const isSelected = selectedBlockPath === blockPath;

  const updateTextProp = useCallback(
    (newContent: string | TipTapContent, newType: "textarea" | "rich-text") => {
      const selectedBlockData = getSelectedBlock();

      if (!selectedBlockData?.block) {
        console.warn("No selected block found for text update");
        return;
      }

      if (!selectedBlockData.block.props?.text) {
        console.warn(
          "Attempted to update text prop on block without text property:",
          selectedBlockData.block.type,
        );
        return;
      }

      try {
        const updatedBlock = structuredClone(selectedBlockData.block);
        updatedBlock.props.text.value = newContent;
        updatedBlock.props.text.type = newType;
        updateSelectedBlock(updatedBlock);
      } catch (error) {
        console.error("Failed to update text property:", error);
      }
    },
    [getSelectedBlock, updateSelectedBlock],
  );

  return useMemo(
    () => ({
      isSelected,
      shouldAllowInlineEditing,
      updateTextProp,
    }),
    [isSelected, shouldAllowInlineEditing, updateTextProp],
  );
};
